import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useReactApexChart from "../../hook/useReactApexChart";

const UserGrowthChart = () => {
  const [timeframe, setTimeframe] = useState("Monthly"); // default value
  const { UserChartSeries, UserChartOption, updateChartData } =
    useReactApexChart(timeframe);

  const handleTimeframeChange = (e) => {
    const selected = e.target.value;
    setTimeframe(selected);
  };

  return (
    <div className="col-xxl-12">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg mb-0">
              Current User Growth Review
            </h6>
          </div>

          <div className="mt-40">
            <div className="margin-16-minus">
              <ReactApexChart
                options={UserChartOption}
                series={UserChartSeries}
                type="area"
                height={250}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGrowthChart;
